import React from 'react'

const ExternalLink = ({ to, children, title, className }) => (
  <a 
    href={to} 
    title={title}
    className={className}
    target="_blank" 
    rel="noopener noreferrer"
  >
    {children}
  </a>
)

export default ExternalLink
